// extracted by mini-css-extract-plugin
export default {"logoWrapper":"BrandLogo_logoWrapper__v8-Tm","heading":"BrandLogo_heading__g-lQY"};